<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th>{{ $t("express.标签名称") }}</th>
            <th v-if="loginType == '2'">{{ $t("express.类型") }}</th>
            <th>{{ $t("express.规格(宽×高)") }}</th>
            <th>{{ $t("express.状态") }}</th>
            <th>{{ $t("express.创建时间") }}</th>
            <th>{{ $t("express.操作") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td class="valign-middle">
              <span class="tx-white">{{ item.name }}</span>
            </td>
            <td v-if="loginType == '2'">
              <span class="tx-white">{{ $t(typeArr[item.type]) }}</span>
            </td>
            <td class="valign-middle">
              <span class="tx-white"
                >{{ item.specWidth }}mm × {{ item.specHeight }}mm</span
              >
            </td>
            <td class="valign-middle">
              <span :class="{ 'tx-success': item.status == 1 }">{{
                $t(statusArr[item.status])
              }}</span>
            </td>
            <td class="valign-middle">{{ item.timeCreated }}</td>
            <td class="valign-middle">
              <a
                v-if="isSysRights('PrintLabel.savePrintTpl')"
                class="mg-r-10 tx-info"
                href="javascript:;"
                @click="modiLabel(item)"
                >{{ $t("express.修改") }}</a
              >
              <a
                v-if="isSysRights('PrintLabel.savePrintHtml')"
                class="mg-r-10 tx-info"
                :href="'/print/print.html?id=' + item.id"
                target="_blank"
                >{{ $t("express.设计标签") }}</a
              >
              <a
                v-if="isSysRights('PrintLabel.delPrint')"
                class="mg-r-10 tx-info"
                href="javascript:;"
                @click="delLable(item.id)"
                >{{ $t("express.删除") }}</a
              >
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td :colspan="loginType == '2' ? 6 : 5">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{ $t("express.没有符合条件的标签") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items"],
  data() {
    return {
      loginType: localStorage.getItem("loginType"),
      statusArr: arrDict.labelStatus,
      typeArr: arrDict.labelType,
    };
  },
  methods: {
    modiLabel(item) {
      this.$emit("modiLabel", item);
    },
    delLable(id) {
      this.$emit("delLable", id);
    },
  },
};
</script>
